module.exports = __webpack_public_path__ + "static/media/bg-about-us-2.21ce1046.jpg";